module.exports = __webpack_public_path__ + "static/DSCF8482-83d3442effb46c499c36f5f73ecd1934.jpg";